import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './index.css';
import { BuilderCallHelperPopupContainer } from '../../../containers/BuilderCallHelperPopupContainer';
import { PhoneButtonContainer } from '../../../containers/PhoneButtonContainer';
import { VILLAGES_COUNT_KEYS } from '../../../interfaces/village';
import { trackGotoListingKpClick } from '../../../tracking';
import { IVillageSchema, MODERATION_STATUS_TYPES } from '../../../types';
import { ButtonLink } from '../../ButtonLink';
import { VillagesCount } from '../../villages_count';

export interface IVillageAboutBuilderProps {
  village: IVillageSchema;
}

interface IVillageAboutBuilderState {
  isCallBuilderPopupOpened: boolean;
}

export class VillageAboutBuilder extends React.Component<IVillageAboutBuilderProps, IVillageAboutBuilderState> {
  public state = {
    isCallBuilderPopupOpened: false,
  };

  public render() {
    const {
      village: { builder },
    } = this.props;
    const { isCallBuilderPopupOpened } = this.state;

    if (!builder || builder?.moderationStatus !== MODERATION_STATUS_TYPES.Published) {
      return <div />;
    }

    const builderImage = {
      backgroundImage: `url(${builder.logoUrl})`,
    };

    return (
      <div className={styles['container']}>
        <div className={styles['builder_info']}>
          <div>
            <span className={styles['builder_badge']}>Застройщик</span>
            <p className={styles['builder_name']}>{builder.name}</p>
            <div className={styles['villages_count_container']}>
              {!!builder.counterSet?.onSale && (
                <VillagesCount
                  label={VILLAGES_COUNT_KEYS.SELLING}
                  count={builder.counterSet.onSale}
                  link={builder.seo?.onSale?.url ?? ''}
                  onLinkClick={trackGotoListingKpClick}
                />
              )}
              {!!builder.counterSet?.sold && (
                <VillagesCount
                  label={VILLAGES_COUNT_KEYS.SOLDOUT}
                  count={builder.counterSet.sold}
                  link={builder.seo?.sold?.url ?? ''}
                  onLinkClick={trackGotoListingKpClick}
                />
              )}
            </div>
            {builder.displayPhone && (
              <ButtonLink linkStyles={styles['builder_popup_link']} onClick={this.onBuilderPopupLinkClick}>
                О чём спросить у застройщика?
              </ButtonLink>
            )}
            {isCallBuilderPopupOpened && (
              <BuilderCallHelperPopupContainer onClose={this.onBuilderCallHelperPopupClose} />
            )}
            {builder.displayPhone && builder.workTime && (
              <p {...mergeStyles(styles['grey_text'], styles['work_time'])}>{builder.workTime}</p>
            )}
          </div>
          <div>
            {builder.logoUrl ? (
              <div className={styles['builder_image']} style={builderImage} />
            ) : (
              <div className={styles['default_builder']}>
                <div className={styles['default_builder_img']} />
              </div>
            )}
          </div>
        </div>
        <PhoneButtonContainer buttonSize="M" fullWidth={true} />
      </div>
    );
  }

  private onBuilderCallHelperPopupClose = () => {
    this.setState({
      isCallBuilderPopupOpened: false,
    });
  };

  private onBuilderPopupLinkClick = () => {
    this.setState({
      isCallBuilderPopupOpened: true,
    });
  };
}
